export enum SenderScoring {
  maxScore = 7,
  minScore = 4,
}
